import { render, staticRenderFns } from "./contractRejected.vue?vue&type=template&id=3b275369&scoped=true"
import script from "./contractRejected.vue?vue&type=script&lang=js"
export * from "./contractRejected.vue?vue&type=script&lang=js"
import style0 from "./contractRejected.vue?vue&type=style&index=0&id=3b275369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b275369",
  null
  
)

export default component.exports